module.exports = __webpack_public_path__ + "static/media/kn.4ad12564.svg";